<template>
  <div class="c-subCategoryListForSeo">
    <h2 class="c-subCategoryListForSeo_title">
      <strong>{{ parentCategoryName }}の関連カテゴリ一覧</strong>
    </h2>
    <template v-for="(item, index) in subCategories">
      <div
        class="c-subCategoryListForSeo_list"
        :key="item.id"
        v-if="childCategoryId !== item.id"
      >
        <NuxtLink
          :to="`/categories/${item.id}?service_kind=${serviceClass.phone}`"
          v-if="isParentCategoryDivinationPhone"
        >［電話占い］{{ item.name }}</NuxtLink>
        <NuxtLink
          :to="`/categories/${item.id}`"
          v-else
        >{{ item.name }}</NuxtLink>
        <span v-if="index + 1 < subCategories.length">｜</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SubCategoryListForSeo',
  props: {
    isParentCategoryDivinationPhone: {
      type: Boolean,
      default: false
    },
    parentCategoryId: {
      type: Number,
      default: null
    },
    childCategoryId: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapState('master', ['masterCategories']),
    ...mapState('constants', ['serviceClass']),
    subCategories() {
      return this.masterCategories.find(i => i.id === this.parentCategoryId)?.subCategories
    },
    parentCategoryName() {
      return this.masterCategories.find(i => i.id === this.parentCategoryId)?.name
    }
  }
}
</script>

<style lang="scss" scoped>
.c-subCategoryListForSeo {
  &_title {
    margin-bottom: 8px;

    strong {
      color: $color-gray-900;
      font-size: 20px;
    }
  }
  &_list {
    display: inline-block;
    font-size: 12px;

    a {
      @include link-effect;

      color: $color-gray-800;
    }
  }
}
</style>
